import {ActionTree, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import api from "@/service/api";
import VueI18n from "@/helpers/i18n";


export interface State {
    surveys: any[];
    survey: any;
    currentSurvey: any;
    loading: string;
    isNotChange: boolean;
    surveysFromServer: any;
}

const defaultState: State = {
    surveys: [],
    survey: [],
    currentSurvey: [],
    loading: "",
    isNotChange: true,
    surveysFromServer: [],
};

const getters = {
    surveys: (state: State) => state.surveys,
    survey: (state: State) => state.survey,
    currentSurvey: (state: State) => state.currentSurvey,
    loading: (state: State) => state.loading,
    isNotChange: (state: State) => state.isNotChange,
    surveysFromServer: (state: State) => state.surveysFromServer,
};

const mutations: MutationTree<State> = {
    setLoadStatus(state: State, payload: any) {
        state.loading = payload;
    },
    setCurrentSurvey(state: State, payload: any[]) {
        state.currentSurvey = payload
    },
    setSurveys(state: State, payload: any[]) {
        state.surveys = payload
    },
    setSurveyTitle(state: State, payload: any) {

        state.surveys.forEach((survey: any) => {
            if (survey._id == payload._id) {
                survey.title = payload.title
            }
        })
    },
    setSurvey(state: State, payload: any) {
        state.survey = payload
        state.surveys.forEach((survey: any) => {
            if (survey._id == payload._id) {
                survey.title = payload.title
                survey.questionsCount = payload.questionsCount
                survey.updateAtTimestamp = payload.updateAtTimestamp
                survey.isArchived = payload.isArchived
                survey.isActive = payload.isActive
            }
        })
    },
    addSurvey(state: State, payload: any) {
        state.surveys.unshift(payload)
    },
    setUpdateSurveys(state: State, payload: any) {
        let arr = state.surveys.map((el: any) => {
            if (el.survey.id === payload.id) {
                payload.questionsCount = el.survey.questionsCount
                el.survey = payload
                return el
            } else {
                return el
            }
        })
        state.surveys = arr
    },
    setIsNotChange(state: State, payload: boolean) {
        state.isNotChange = payload
    },
    setSurveysFromServer(state: State, payload: any[]) {
        // VueI18n.locale = store.state.locale.locale
        const s = payload.map((survey: any) => {
            return {id: survey._id, text: survey.title}
        })
        // s.unshift( {id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')})
        state.surveysFromServer = s
    },
};

const actions: ActionTree<State, RootState> = {

    async getSurveys({commit, state}, payload: any) {
        try {
            const {data} = await api.go('getSurveys', {params: payload})
            if (data.error) {
                throw (data.error)
            }
            commit('setSurveys', data.data.surveys)
            commit('setSurveysFromServer', data.data.surveys)
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                messages: [e]
            })
            console.log(e.message)
        }
    },
    async createSurvey({commit, state}, payload: any) {
        try {
            const {data} = await api.go('createSurvey', {params: payload.params, body: payload.body})
            if (data.error) {
                throw (data.error)
            }
            data.data.survey.isEdit = false
            commit('setSurvey', data.data.survey)
            commit('addSurvey', data.data.survey)
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                messages: [e]
            })
            console.log(e.message)
        }
    },
    async getSurvey({commit, state}, payload: any) {
        try {
            const {data} = await api.go('getSurvey', {params: payload})
            if (data.error) {
                throw (data.error)
            }
            data.data.survey.isEdit = false
            commit('setSurvey', data.data.survey)
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                messages: [e]
            })
            console.log(e.message)
        }
    },
    async changeActiveFalse({commit, state}, payload: any) {
        try {
            await api.go('editSurvey', {params: payload.params, body: payload.body})
            const {data} = await api.go('getSurvey', {params: payload.params})
            if (data.error) {
                throw (data.error)
            }
            data.data.survey.isEdit = true

            commit('setSurvey', data.data.survey)
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                messages: [e]
            })
            console.log(e.message)
        }
    },
    async editSurveyTitle({commit, state}, payload: any) {
        try {
            const {data} =  await api.go('editSurvey', {params: payload.params, body: payload.body})

            if (data.error) { throw (data.error)}

            commit('setSurveyTitle', data.data.survey)

            this.commit('alerts/setAlert', {
                show: true,
                messages: [VueI18n.t('mailing.status.save')]
            })
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                messages: [e]
            })
        }
    },
    async editSurvey({commit, state}, payload: any) {
        try {
            await api.go('editSurvey', {params: payload.params, body: payload.body})
            const {data} = await api.go('getSurvey', {params: payload.params})
            if (data.error) {
                throw (data.error)
            }
            data.data.survey.isEdit = false

            commit('setSurvey', data.data.survey)
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e]
            })
            console.log(e.message)
        }
    },
    showEditAlert({commit, state}, payload: any) {
        this.commit('alerts/setAlert', {
            show: true,
            color: 'red',
            messages: [payload]
        })
    }
};

export default {
    namespaced: true,
    state: defaultState,
    getters,
    mutations,
    actions,
};
